'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.ci)));
}
export { $is_ju_Map as $is_ju_Map };
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ci)));
}
export { $isArrayOf_ju_Map as $isArrayOf_ju_Map };
